<template>
  <div class="com">
    <button class="close" @click="closeModal">
      <CloseIcone></CloseIcone>
    </button>
    <div class="button-container">
      <button class="print-btn" @click="callPrint">Print</button>
      <button
        class="print-btn"
        style="margin-left:10px;"
        v-show="selectedStatus === 'lab_awaiting' && !enableEdit"
        @click="editDetails"
      >Edit</button>
      <button
        class="print-btn"
        style="margin-left:10px;"
        v-show="selectedStatus === 'lab_awaiting' && enableEdit"
        @click="cancelEdit"
      >Cancel</button>
      <button
        class="print-btn"
        style="margin-left:10px;"
        v-show="selectedStatus === 'lab_awaiting' && !showLog"
        @click="toggleLog"
      >Show log</button>
      <button
        class="print-btn"
        style="margin-left:10px;"
        v-show="selectedStatus === 'lab_awaiting' && showLog"
        @click="toggleLog"
      >Back</button>
      <span class="share-span">
        <img
          class="share-btn-img"
          src="../../images/dashboard/icons8-share.png"
          alt="#"
          @click="shareStatus"
        />
      </span>
    </div>
    <div v-show="showLog">
      <DisplayLog></DisplayLog>
    </div>
    <div v-show="!showLog">
      <div class="title">
        <span>Test Kit Tracking</span>
        <div class="id">
          <span style="padding: 1.5px 0 0 0">KIT ID:</span>
          <input
            :readonly="readonly"
            class="kit-input"
            type="text"
            name="kit_id"
            v-validate="{ required: true, length: 20 }"
            v-model="convertedKitId"
            v-mask="'XX - XX - XXX - XXXX'"
          />
        </div>
        <span class="validate-error right" v-if="errors.has('kit_id')">{{
          errors.first("kit_id")
        }}</span>
      </div>
      <!-- Timeline. DNA Extraction / Sequencing are driven by the MTC lab portal
           (before Lab Received) — there is no admin advance control here. -->
      <KitTimelineV2 :kit="kit" />
      <div class="title">
        <span>Test Kit Information</span>
      </div>
      <div class="proj-wrap">
        <div class="col">
          <div class="item">
            <div class="item-title">Project Name</div>
            <div class="item-val" v-if="enableEdit">
              <input
                type="text"
                class="edit-input"
                v-model="editTitle"
                placeholder="Project Name"
              />
            </div>
            <div class="item-val" v-else-if="kit.title !== null && kit.title !== undefined">
              {{ kit.title }}
            </div>
            <div class="item-val noData" v-else>No Data</div>
          </div>
        </div>
        <div class="col">
          <div class="item">
            <div class="item-title">Shipment Tracking</div>
            <div class="item-val">
              To Lab:&nbsp;
              
              <span v-if="track_number !== null && ship_method !== null">
                <a target="_blank" v-if="ship_method === 'USPS'" :href="`https://tools.usps.com/go/TrackConfirmAction?tRef=fullpage&tLc=2&text28777=&tLabels=${track_number}%2C&tABt=true`" class="btn-link">
                  Track.
                </a>
                <a target="_blank" v-else-if="ship_method === 'DHL'" :href="`https://webtrack.dhlglobalmail.com/orders?trackingNumber=${track_number}`" class="btn-link">
                  Track.
                </a>
                <a target="_blank" v-else-if="ship_method === 'FEDEX'" :href="`https://www.fedex.com/fedextrack/?trknbr=${track_number}`" class="btn-link">
                  Track.
                </a>
                <a target="_blank" v-else-if="ship_method === 'UPS'" :href="`https://www.ups.com/track?track=yes&trackNums=${track_number}&loc=en_US&requester=ST/`" class="btn-link">
                  Track.
                </a>
              </span>
              <span v-else>
                No Tracking Data.
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="date-wrap">
        <div class="col">
          <div class="item">
            <div class="item-title">Ship Date</div>
            <div class="item-val" v-if="kit.shipped_at !== null && kit.shipped_at !== undefined">
              {{ date(kit.shipped_at) }}
            </div>
            <div class="item-val noData" v-else>No Data</div>
          </div>
          <div class="item">
            <div class="item-title">Status</div>
            <div class="status-wrap" v-click-outside="closeModel">
              <div class="item-val status">
                <span
                  class="item-val-span hold"
                  v-if="selectedStatus === 'on_hold'"
                  style="color: #E87A01;"
                >
                  <span class="circle" style="background-color: #E87A01;"></span>
                  On Hold
                </span>
                <button
                  class="onhold-btn"
                  v-if="kitStatus === 'on_hold' && selectedStatus === 'on_hold'"
                  @click.stop="stopPropagation"
                  @click="showComment"
                >
                  <img
                    class="onhold-btn-img"
                    src="../../images/dashboard/onhold.png"
                    alt="#"
                  />
                </button>
                <span class="item-val-span" v-if="selectedStatus === 'analysis_completed'">
                  <span class="circle green"></span>Analysis Complete
                </span>
                <span class="item-val-span" v-if="selectedStatus === 'analysis_failed'">
                  <span class="circle red"></span>Analysis Failed
                </span>
                <span class="item-val-span" v-if="selectedStatus === 'partially_failed'">
                  <span class="circle green"></span>Analysis Partially Complete
                </span>
                <span
                  class="item-val-span"
                  @click="showDropDownFn"
                  v-if="selectedStatus === 'lab_awaiting'"
                >
                  <span class="circle purple"></span>Submitted
                  <img class="item-val-img" src="../../images/dashboard/statusDrop.png" alt="#" />
                </span>
                <span
                  class="item-val-span"
                  @click="showDropDownFn"
                  v-if="selectedStatus === 'lab_received'"
                >
                  <span class="circle orange"></span>Lab Received
                  <img class="item-val-img" src="../../images/dashboard/statusDrop.png" alt="#" />
                </span>
                <span
                  class="item-val-span"
                  @click="showDropDownFn"
                  v-if="selectedStatus === 'accepted'"
                >
                  <span class="circle" style="background-color:#0EA5E9;"></span>Accepted
                  <img class="item-val-img" src="../../images/dashboard/statusDrop.png" alt="#" />
                </span>
                <span
                  class="item-val-span"
                  @click="showDropDownFn"
                  v-if="selectedStatus === 'dna_extraction'"
                >
                  <span class="circle" style="background-color:#17A2B8;"></span>DNA Extraction In Progress
                  <img class="item-val-img" src="../../images/dashboard/statusDrop.png" alt="#" />
                </span>
                <span
                  class="item-val-span"
                  @click="showDropDownFn"
                  v-if="selectedStatus === 'sequencing'"
                >
                  <span class="circle" style="background-color:#6F42C1;"></span>Sequencing In Progress
                  <img class="item-val-img" src="../../images/dashboard/statusDrop.png" alt="#" />
                </span>
                <span class="item-val-span" v-if="selectedStatus === 'shipped'">
                  <span class="circle blue"></span> Sold
                </span>
                <span class="item-val-span" v-if="selectedStatus === 'delivered'">
                  <span class="circle skyblue"></span> Delivered
                </span>
                <div class="filter-wrap" v-click-outside="closeDropDown">
                  <span
                    class="item-val-span"
                    @click="showSelectDropFn"
                    v-if="selectedStatus === 'archive'"
                  >
                    <span class="circle orange"></span>Archived
                    <img class="item-val-img" src="../../images/dashboard/statusDrop.png" alt="#" />
                  </span>
                  <ul class="filter-list-wrap" v-show="showSelectDrop">
                    <li class="filter-list-item hide">Status</li>
                    <li class="filter-list-item" @click="setItem(0)">Sold</li>
                    <li class="filter-list-item" @click="setItem(6)">Delivered</li>
                    <li class="filter-list-item" @click="setItem(1)">Activated</li>
                    <li class="filter-list-item" @click="setItem(2)">Submitted</li>
                    <li class="filter-list-item" @click="setItem(3)">Lab Received</li>
                    <li class="filter-list-item" @click="setItem(4)">On Hold</li>
                    <li class="filter-list-item" @click="setItem(5)">Analysis Complete</li>
                  </ul>
                </div>
                <span
                  class="item-val-span"
                  @click="showDropDownFn"
                  v-if="selectedStatus === 'activated'"
                >
                  <span class="circle"></span>Activated
                  <img class="item-val-img" src="../../images/dashboard/statusDrop.png" alt="#" />
                </span>
              </div>
              <ul class="dropDown" v-show="showDropDown">
                <li
                  v-for="item in statusOptions"
                  v-bind:key="item"
                  class="dropDown-item"
                  :class="[
                    { undisabled: selectedStatus === 'shipped' && item === 1 },
                    { undisabled: selectedStatus === 'activated' && item === 2 },
                    { undisabled: selectedStatus === 'lab_awaiting' && item === 3 },
                    { undisabled: selectedStatus === 'lab_received' && (item === 4 || item === 5) }
                  ]"
                >
                  <span v-if="item === 0" @click="setItem(item)">Sold</span>
                  <span v-if="item === 1" @click="setItem(item)">Activated</span>
                  <span v-if="item === 6" @click="setItem(item)">Delivered</span>
                  <span v-if="item === 2" @click="setItem(item)">Submitted</span>
                  <span v-if="item === 3" @click="setItem(item)">Lab Received</span>
                  <span v-if="item === 4" @click="setItem(item)">On Hold</span>
                  <span v-if="item === 5" @click="setItem(item)">Analysis Complete</span>
                  <span v-if="item === 10" @click="setItem(item)">Analysis Failed</span>
                  <span v-if="item === 11" @click="setItem(item)">Analysis Partially Complete</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="item" v-if="showReportSla">
            <div class="item-title">Report</div>
            <div class="item-val"><span class="circle" style="background-color:#F59E0B;"></span>Report Pending</div>
            <div class="item-val" v-if="expectedReportDate">Expected: {{ expectedReportDate }}</div>
            <div class="item-val" v-if="dueInBusinessDays !== null">
              Due in {{ dueInBusinessDays }} Business Day{{ dueInBusinessDays === 1 ? '' : 's' }}
            </div>
          </div>
          <div class="item">
            <div class="item-title">Send Report Copy To</div>
            <div class="item-val" v-if="kit.report_forward_email !== null && kit.report_forward_email !== undefined">
              {{ kit.report_forward_email }}
            </div>
            <div class="item-val noData" v-else>N/A</div>
          </div>
          <div class="item" v-if="selectedStatus === 'archive'">
            <div class="item-title">Archive Date</div>
            <div class="item-val" v-if="kit.archived_at !== null && kit.archived_at !== undefined">
              {{ date(kit.archived_at) }}
            </div>
            <div class="item-val noData" v-else>No Data</div>
          </div>
        </div>
        <div class="col">
          <div class="item">
            <div class="item-title">Date of Submission</div>
            <div class="item-val" v-if="kit.submission_at !== null && kit.submission_at !== undefined">
              {{ date(kit.submission_at) }}
            </div>
            <div class="item-val noData" v-else>No Data</div>
          </div>
          <div class="item">
            <div class="item-title">Date of Activation</div>
            <div class="item-val" v-if="kit.activated_at !== null && kit.activated_at !== undefined">
              {{ date(kit.activated_at) }}
            </div>
            <div class="item-val noData" v-else>No Data</div>
          </div>
        </div>
      </div>
      <!-- V2: Sampling Location from nested address -->
      <div class="location">
        <div class="col">
          <div class="item">
            <div class="item-title">Sampling Location</div>
            <div class="item-val edit-address" v-if="enableEdit">
              <input
                type="text"
                class="edit-input"
                v-model="editAddress"
                placeholder="Street Address"
              />
              <div class="edit-address-row">
                <input
                  type="text"
                  class="edit-input edit-input--city"
                  v-model="editCity"
                  placeholder="City"
                />
                <input
                  type="text"
                  class="edit-input edit-input--state"
                  v-model="editState"
                  placeholder="State"
                />
                <input
                  type="text"
                  class="edit-input edit-input--zip"
                  v-model="editZip"
                  placeholder="Zip"
                />
              </div>
            </div>
            <div class="item-val" v-else-if="samplingLocation">
              {{ samplingLocation }}
            </div>
            <div class="item-val noData" v-else>No Data</div>
          </div>
        </div>
        <div class="col">
          <div class="item">
            <div class="item-title">Sampling Date</div>
            <div class="item-val" v-if="enableEdit">
              <input
                type="date"
                class="edit-input"
                v-model="editSamplingDate"
              />
            </div>
            <div class="item-val" v-else-if="kit.sampling_date !== null && kit.sampling_date !== undefined">
              {{ date(kit.sampling_date) }}
            </div>
            <div class="item-val noData" v-else>No Data</div>
          </div>
        </div>
      </div>
      <!-- V2: Result display (single result field instead of indoor samples) -->
      <div class="details" v-if="kit.result !== null && kit.result !== undefined">
        <div class="details-title">REPORT RESULT</div>
        <div class="row">
          <div class="row-item">
            <span class="status green" v-if="kit.result === 0">Normal Fungal Ecology</span>
            <span class="status yellow" v-if="kit.result === 1">Slightly Disrupted</span>
            <span class="status orange" v-if="kit.result === 2">Moderately Disrupted</span>
            <span class="status red" v-if="kit.result === 3">Significantly Disrupted</span>
          </div>
        </div>
      </div>
      <div class="details" v-else-if="selectedStatus === 'analysis_completed' || selectedStatus === 'partially_failed'">
        <div class="details-title">REPORT RESULT</div>
        <div class="row">
          <div class="row-item">
            <span class="status">N/A</span>
          </div>
        </div>
      </div>

        <!-- Outdoor Samples -->
      <div class="details samples-block" v-if="outdoorSamples.length > 0">
        <div class="details-title">
          OUTDOOR SAMPLES
          <span class="sample-count">({{ outdoorSamples.length }})</span>
        </div>
        <div
          class="sample-row"
          v-for="(sample, index) in outdoorSamples"
          :key="'outdoor-' + index"
        >
          <div class="sample-row-label">
            <span class="circle"></span>
            Outdoor Sample
          </div>
          <div class="sample-row-name">
            <span v-if="sample.value">{{ sample.value }}</span>
            <span class="noData" v-else>No Data</span>
          </div>
        </div>
      </div>
      
      <!-- Indoor Samples -->
      <div class="details samples-block" v-if="indoorSamples.length > 0">
        <div class="details-title">
          INDOOR SAMPLES
          <span class="sample-count">({{ indoorSamples.length }})</span>
        </div>
        <div
          class="sample-row"
          v-for="(sample, index) in indoorSamples"
          :key="'indoor-' + (sample.id || index)"
        >
          <div class="sample-row-label">
            <span class="circle" :class="sampleResultColor(sample)"></span>
            Indoor Sample #{{ index + 1 }}
          </div>
          <div class="sample-row-name">
            <div
              v-if="enableEdit"
              class="sample-dropdown-container"
              v-on:mouseleave="closeSampleDropdown()"
            >
              <input
                :name="'Indoor Sample #' + (index + 1)"
                :value="editSamples[index] ? editSamples[index].type : ''"
                @click="openSampleDropdown(index)"
                placeholder="Select"
                readonly
                class="edit-input sample-dropdown-input"
              />
              <img
                class="sample-dropdown-arrow"
                src="../../images/dashboard/statusDrop.png"
                alt="#"
              />
              <ul
                class="sample-dropdown-list"
                v-show="activeSampleDropdown === index"
              >
                <li
                  v-for="option in indoorOptions"
                  :key="option"
                  class="sample-dropdown-item"
                  :class="{ disabled: isSampleTypeTaken(option, index) }"
                  @click="!isSampleTypeTaken(option, index) && setSampleType(option, index)"
                ><span>{{ option }}</span></li>
                <li class="sample-dropdown-item sample-dropdown-item--input">
                  <input
                    type="text"
                    :value="editSamples[index] ? editSamples[index].type : ''"
                    @input="setSampleType($event.target.value, index)"
                    class="sample-dropdown-other"
                    @keyup.enter="closeSampleDropdown()"
                    placeholder="Enter Other Description"
                    maxlength="33"
                  />
                </li>
              </ul>
            </div>
            <span v-else-if="sample.type">{{ sample.type }}</span>
            <span class="noData" v-else-if="!enableEdit">No Data</span>
          </div>
          <div class="sample-row-status" v-if="!isKitInCreation">
            <span :class="['status', sampleResultClass(sample)]">
              {{ sampleResultText(sample) }}
            </span>
          </div>
        </div>
      </div>

      <!-- Answers to Questions (V1 parity: horizontal inline layout) -->
      <div class="details answers-border">
        <div class="details-title">ANSWERS TO QUESTIONS</div>
        <div class="item-val answers-row">
          <span class="answer-group">
            <span class="answer-prompt">Visible mold:</span>
            <label
              v-if="enableEdit"
              class="answer-toggle-label"
              :class="{ active: editVisibleMold }"
            >
              <input type="checkbox" v-model="editVisibleMold" />
              <span class="answer-toggle-text">{{ editVisibleMold ? "Yes" : "No" }}</span>
            </label>
            <b v-else class="answer">{{
              kit.visible_mold === true
                ? "Yes"
                : kit.visible_mold === false
                ? "No"
                : "No Data"
            }}</b>
          </span>

          <span class="answer-group">
            <span class="answer-prompt">"Musty" or a "damp":</span>
            <label
              v-if="enableEdit"
              class="answer-toggle-label"
              :class="{ active: editMustyDampOdor }"
            >
              <input type="checkbox" v-model="editMustyDampOdor" />
              <span class="answer-toggle-text">{{ editMustyDampOdor ? "Yes" : "No" }}</span>
            </label>
            <b v-else class="answer">{{
              kit.musty_damp_odor === true
                ? "Yes"
                : kit.musty_damp_odor === false
                ? "No"
                : "No Data"
            }}</b>
          </span>

          <span class="answer-group">
            <span class="answer-prompt">Symptoms:</span>
            <label
              v-if="enableEdit"
              class="answer-toggle-label"
              :class="{ active: editSymptoms }"
            >
              <input type="checkbox" v-model="editSymptoms" />
              <span class="answer-toggle-text">{{ editSymptoms ? "Yes" : "No" }}</span>
            </label>
            <b v-else class="answer">{{
              kit.symptoms === true
                ? "Yes"
                : kit.symptoms === false
                ? "No"
                : "No Data"
            }}</b>
          </span>
        </div>
      </div>

      <!-- Per-Sample FASTQ R1/R2 Uploads -->
      <div
        class="details fastq-block"
        v-if="
          role === 'superadmin' &&
          selectedStatus !== 'shipped' &&
          selectedStatus !== 'activated' &&
          (indoorSamples.length > 0 || outdoorSamples.length > 0)
        "
      >
        <div class="details-title">SAMPLE FASTQ FILES</div>

        <div class="fastq-section" v-if="indoorSamples.length > 0">
          <div class="fastq-subtitle">Indoor Samples</div>
          <div
            class="sample-card"
            v-for="(sample, index) in indoorSamples"
            :key="'fastq-in-' + index"
          >
            <div class="sample-card-header">
              {{ sampleDisplayName(sample, index, 'indoor') }}
              <span class="sample-card-slug">({{ sampleSlug(sample, index, 'indoor') }})</span>
            </div>
            <div class="fastq-row" v-for="read in ['R1', 'R2']" :key="'in-' + index + '-' + read">
              <div class="fastq-row-label">
                {{ read }} FASTQ
                <span class="required-marker">*</span>
              </div>
              <!-- Existing file display -->
              <div class="fastq-existing" v-if="getSampleFastq('indoor', index, read)">
                <span class="file-type-badge type-fastq">{{ read }}</span>
                <span class="uploaded-file-name">{{ getSampleFastq('indoor', index, read).file_name }}</span>
                <span class="uploaded-file-date">{{ date(getSampleFastq('indoor', index, read).created_at) }}</span>
                <button
                  class="file-action download-action"
                  type="button"
                  @click.stop.prevent="onDownloadFile(getSampleFastq('indoor', index, read))"
                  :disabled="downloadingFileId === getSampleFastq('indoor', index, read).id"
                  title="Download"
                >{{ downloadingFileId === getSampleFastq('indoor', index, read).id ? 'Downloading...' : 'Download' }}</button>
              </div>
              <!-- New FASTQ upload slot -->
              <span
                class="download-link span"
                :class="{ 'slot-missing': isSlotMissing('indoor', index, read) }"
                v-else
              >
                <input
                  class="download-input"
                  :id="'upload_fastq_in_' + index + '_' + read"
                  :ref="'fastqInInput_' + index + '_' + read"
                  @change="onSampleFastqSelected($event, 'indoor', index, read)"
                  type="file"
                  accept=".fastq,.fastq.gz"
                />
                <label :for="'upload_fastq_in_' + index + '_' + read" class="download upload_csv">
                  <img
                    class="upload-img"
                    src="../../images/dashboard/download.svg"
                    alt="#"
                  />
                </label>
                <label :for="'upload_fastq_in_' + index + '_' + read" class="download-txt upload_csv">
                  {{ getStagedFastq('indoor', index, read) ? getStagedFastq('indoor', index, read).name : 'Upload ' + read + ' FASTQ' }}
                </label>
                <button
                  v-if="getStagedFastq('indoor', index, read)"
                  class="remove-file-btn"
                  type="button"
                  @click.stop="removeSampleFastq('indoor', index, read)"
                  title="Remove"
                >&times;</button>
              </span>
              <div
                class="slot-error"
                v-if="getSlotTypeError('indoor', index, read) || isSlotMissing('indoor', index, read)"
              >
                {{ getSlotTypeError('indoor', index, read) || (read + ' FASTQ file is required') }}
              </div>
            </div>
          </div>
        </div>

        <div class="fastq-section" v-if="outdoorSamples.length > 0">
          <div class="fastq-subtitle">Outdoor Samples</div>
          <div
            class="sample-card"
            v-for="(sample, index) in outdoorSamples"
            :key="'fastq-out-' + index"
          >
            <div class="sample-card-header">
              {{ sampleDisplayName(sample, index, 'outdoor') }}
              <span class="sample-card-slug">({{ sampleSlug(sample, index, 'outdoor') }})</span>
            </div>
            <div class="fastq-row" v-for="read in ['R1', 'R2']" :key="'out-' + index + '-' + read">
              <div class="fastq-row-label">
                {{ read }} FASTQ
                <span class="required-marker">*</span>
              </div>
              <div class="fastq-existing" v-if="getSampleFastq('outdoor', index, read)">
                <span class="file-type-badge type-fastq">{{ read }}</span>
                <span class="uploaded-file-name">{{ getSampleFastq('outdoor', index, read).file_name }}</span>
                <span class="uploaded-file-date">{{ date(getSampleFastq('outdoor', index, read).created_at) }}</span>
                <button
                  class="file-action download-action"
                  type="button"
                  @click.stop.prevent="onDownloadFile(getSampleFastq('outdoor', index, read))"
                  :disabled="downloadingFileId === getSampleFastq('outdoor', index, read).id"
                  title="Download"
                >{{ downloadingFileId === getSampleFastq('outdoor', index, read).id ? 'Downloading...' : 'Download' }}</button>
              </div>
              <span
                class="download-link span"
                :class="{ 'slot-missing': isSlotMissing('outdoor', index, read) }"
                v-else
              >
                <input
                  class="download-input"
                  :id="'upload_fastq_out_' + index + '_' + read"
                  :ref="'fastqOutInput_' + index + '_' + read"
                  @change="onSampleFastqSelected($event, 'outdoor', index, read)"
                  type="file"
                  accept=".fastq,.fastq.gz"
                />
                <label :for="'upload_fastq_out_' + index + '_' + read" class="download upload_csv">
                  <img
                    class="upload-img"
                    src="../../images/dashboard/download.svg"
                    alt="#"
                  />
                </label>
                <label :for="'upload_fastq_out_' + index + '_' + read" class="download-txt upload_csv">
                  {{ getStagedFastq('outdoor', index, read) ? getStagedFastq('outdoor', index, read).name : 'Upload ' + read + ' FASTQ' }}
                </label>
                <button
                  v-if="getStagedFastq('outdoor', index, read)"
                  class="remove-file-btn"
                  type="button"
                  @click.stop="removeSampleFastq('outdoor', index, read)"
                  title="Remove"
                >&times;</button>
              </span>
              <div
                class="slot-error"
                v-if="getSlotTypeError('outdoor', index, read) || isSlotMissing('outdoor', index, read)"
              >
                {{ getSlotTypeError('outdoor', index, read) || (read + ' FASTQ file is required') }}
              </div>
            </div>
          </div>
        </div>

        <button
          class="upload-submit-btn"
          type="button"
          @click.stop="uploadSampleFastqFiles"
          :disabled="uploadingSampleFastq || !canSubmitSampleFastq"
        >
          {{ uploadingSampleFastq ? 'Uploading...' : 'Submit FASTQ Files' }}
        </button>
        <span class="uploadTxt">
          <span class="success" v-if="sampleFastqSuccess">{{ sampleFastqSuccess }}</span>
        </span>
      </div>

      <!-- Download / Upload section -->
      <div class="btns-complate-wrap" id="btns-complate-wrap">
        <div
          class="download-wrap"
          v-show="
            selectedStatus === 'analysis_completed' ||
            selectedStatus === 'partially_failed' ||
            selectedStatus === 'on_hold' ||
            selectedStatus === 'lab_received' ||
            selectedStatus === 'analysis_failed'
          "
        >
          <button
            class="download-link download-link-btn"
            title="Download"
            v-if="selectedStatus === 'analysis_completed'"
            @click.prevent="getFile"
          >
            <span class="download-circle">
              <img src="../../images/dashboard/download.svg" alt="#" />
            </span>
            <span class="download-txt-v1">Download full report (PDF)</span>
          </button>
          <div class="upload-block" v-if="role === 'superadmin' && nonSlotFiles.length > 0">
            <ul class="uploaded-files-list">
              <li v-for="f in nonSlotFiles" :key="f.id">
                <span class="file-type-badge" :class="'type-' + (f.file_type || 'file')">
                  {{ (f.file_type || 'FILE').toUpperCase() }}
                </span>
                <span class="uploaded-file-name">{{ f.file_name }}</span>
                <span class="uploaded-file-date">{{ date(f.created_at) }}</span>
                <button
                  class="file-action download-action"
                  type="button"
                  @click.stop.prevent="onDownloadFile(f)"
                  :disabled="downloadingFileId === f.id"
                  title="Download"
                >{{ downloadingFileId === f.id ? "Downloading..." : "Download" }}</button>
                <button
                  class="file-action delete-action"
                  type="button"
                  @click.stop.prevent="askDeleteFile(f)"
                  :disabled="deletingFileId === f.id"
                  title="Delete"
                >{{ deletingFileId === f.id ? "Deleting..." : "Delete" }}</button>
              </li>
            </ul>
          </div>
        </div>
        <span
          class="download-txt non-downloading"
          :class="{ downloading: showPreloader }"
        >Waiting for download...</span>
      </div>
      <button
        class="btn save"
        @click="editData"
        :disabled="errors.any()"
      >
        Save
      </button>
      <ConfirmShareKitStatus
        :KitInfo="kit"
        v-show="showShareStatus"
        @closeShareStatus="closeShareStatus"
      />
      <div class="saveTxt">{{ saveTxt }}</div>
      <Alert
        v-if="alertModal"
        :message="message"
        @closeAlertModal="closeAlertModal"
      />
      <div
        v-if="fileToDelete"
        class="confirm-overlay"
        @click.stop.prevent="cancelDeleteFile"
      >
        <div class="confirm-box" @click.stop>
          <div class="confirm-title">Delete file?</div>
          <div class="confirm-body">
            Are you sure you want to delete
            <strong>{{ fileToDelete.file_name }}</strong>?
            This action cannot be undone.
          </div>
          <div class="confirm-actions">
            <button
              type="button"
              class="confirm-btn cancel"
              @click.stop.prevent="cancelDeleteFile"
              :disabled="deletingFileId === fileToDelete.id"
            >Cancel</button>
            <button
              type="button"
              class="confirm-btn delete"
              @click.stop.prevent="confirmDeleteFile"
              :disabled="deletingFileId === fileToDelete.id"
            >{{ deletingFileId === fileToDelete.id ? "Deleting..." : "Delete" }}</button>
          </div>
        </div>
      </div>
    </div>
    <template>
      <div class="resend-report-btn-wrap" v-show="!showLog">
        <a class="download-link" @click.prevent="resendLatestNotification(kit.id)">
          <label class="download upload_csv">
            <img class="custom-mail" src="../../images/dashboard/mail.png" alt="#" />
          </label>
          <label class="download-txt upload_csv">Resend Last Notice</label>
        </a>
      </div>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { mask } from "vue-the-mask";
import { mapActions, mapGetters } from "vuex";
import CloseIcone from "../../images/shared/cancel";
import Alert from "../../components/dashboard/AdminAlert";
import KitTimelineV2 from "../components/KitTimelineV2.vue";
import ConfirmShareKitStatus from "../../components/dashboard/modal/ConfirmShareKitStatus.vue";
import DisplayLog from "../../components/dashboard/log/DisplayLog";

const STATUS_MAP = {
  0: "shipped", 1: "activated", 2: "lab_awaiting", 3: "lab_received",
  4: "on_hold", 5: "analysis_completed", 6: "problem", 7: "delivered",
  8: "archive", 9: "returned", 10: "analysis_failed", 11: "partially_failed", 12: "in_active",
  13: "dna_extraction", 14: "sequencing", 15: "report_ready", 16: "accepted"
};

export default {
  name: "ModalDescV2",
  directives: { mask },
  props: ["personalData", "emailErrorObj", "validationError"],
  data() {
    return {
      api_url: process.env.VUE_APP_API_URL,
      kit: {},
      showDropDown: false,
      showSelectDrop: false,
      selectedStatus: null,
      track_number: null,
      ship_method: null,
      reportLink: null,
      upload: null,
      start: 0,
      convertedKitId: "",
      readonly: true,
      uploadTxt: "",
      failUploadTxt: "",
      saveTxt: "",
      // Business-facing statuses only. The internal lab stages (Accepted 16 /
      // DNA Extraction 13 / Sequencing 14) are driven by the lab portal via
      // lab_stage and are intentionally NOT settable from the admin status menu —
      // they would otherwise leak the lab's internal workflow into the business
      // status (the kit stays "Lab Received" throughout lab processing).
      // Report Ready (15) has been folded into Completed (analysis_completed, 5)
      // and is no longer a separately settable status.
      statusOptions: [0, 1, 2, 3, 4, 5],
      showPreloader: false,
      alertModal: false,
      message: null,
      showShareStatus: false,
      uploading: false,
      uploadSuccess: false,
      uploadValidationError: "",
      existingFiles: [],
      deletingFileId: null,
      downloadingFileId: null,
      fileToDelete: null,
      fileActionSuccess: "",
      indoorFastqStaged: {},
      outdoorFastqStaged: {},
      uploadingSampleFastq: false,
      sampleFastqSuccess: "",
      indoorFastqTypeErrors: {},
      outdoorFastqTypeErrors: {},
      enableEdit: false,
      showLog: false,
      editTitle: "",
      editSamplingDate: "",
      editAddress: "",
      editCity: "",
      editState: "",
      editZip: "",
      editVisibleMold: false,
      editMustyDampOdor: false,
      editSymptoms: false,
      editSamples: [],
      activeSampleDropdown: -1,
      indoorOptions: [
        "Attic", "Basement", "Bathroom", "Crawlspace", "Dining Room",
        "Garage", "Living Room", "Master Bedroom", "Utility Room",
        "Water Heater Closet", "Family Room"
      ]
    };
  },
  components: {
    CloseIcone,
    Alert,
    KitTimelineV2,
    ConfirmShareKitStatus,
    DisplayLog
  },
  computed: {
    ...mapGetters(["getTestKitInfoV2", "role"]),
    kitStatus() {
      return this.statusOf(this.kit.status);
    },
    showReportSla() {
      // The report is pending throughout the lab's internal processing, during
      // which the business status stays Lab Received.
      return this.selectedStatus === "lab_received";
    },
    expectedReportDate() {
      if (!this.kit || !this.kit.expected_report_at) return null;
      const d = new Date(this.kit.expected_report_at);
      if (isNaN(d.getTime())) return null;
      return d.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
    },
    dueInBusinessDays() {
      if (!this.kit || !this.kit.expected_report_at) return null;
      const target = new Date(this.kit.expected_report_at);
      if (isNaN(target.getTime())) return null;
      const today = new Date();
      target.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);
      if (target <= today) return 0;
      let count = 0;
      const cursor = new Date(today);
      while (cursor < target) {
        cursor.setDate(cursor.getDate() + 1);
        const dow = cursor.getDay();
        if (dow !== 0 && dow !== 6) count += 1;
      }
      return count;
    },
    samplingLocation() {
      if (!this.kit || !this.kit.address) return null;
      const a = this.kit.address;
      if (a.address && a.city && a.state && a.zip) {
        return `${a.address}, ${a.city}, ${a.state} ${a.zip}`;
      }
      return null;
    },
    indoorSamples() {
      const samples = (this.kit && Array.isArray(this.kit.samples)) ? this.kit.samples : [];
      return samples.slice().sort((a, b) => (a.sample_order || 0) - (b.sample_order || 0));
    },
    outdoorSamples() {
      // Every V2 kit always has exactly one outdoor sample by design; show
      // the row even before the customer has filled it in (value can be empty).
      if (!this.kit || !this.kit.id) return [];
      return [{ value: this.kit.outdoor_sample || "" }];
    },
    isKitInCreation() {
      // "Creation" covers the pre-lab window: kit just sold or activated.
      // Status badges (In Progress / Completed / N/A) only make sense once
      // the kit has been submitted to the lab.
      return this.selectedStatus === "shipped" || this.selectedStatus === "activated";
    },
    nonSlotFiles() {
      const SLOT_TYPES = new Set([
        "faq_indoor",
        "faq_outdoor",
        "fastq_indoor_r1",
        "fastq_indoor_r2",
        "fastq_outdoor_r1",
        "fastq_outdoor_r2"
      ]);
      return this.existingFiles.filter(f => !SLOT_TYPES.has(f.file_type));
    },
    hasStagedSampleFastq() {
      const hasAny = bucket =>
        Object.keys(bucket).some(idx => {
          const slots = bucket[idx] || {};
          return !!(slots.R1 || slots.R2);
        });
      return (
        hasAny(this.indoorFastqStaged) || hasAny(this.outdoorFastqStaged)
      );
    },
    missingFastqSlots() {
      const missing = [];
      const check = (kind, samples) => {
        for (let i = 0; i < samples.length; i += 1) {
          ["R1", "R2"].forEach(read => {
            const existing = this.getSampleFastq(kind, i, read);
            const staged = this.getStagedFastq(kind, i, read);
            if (!existing && !staged) {
              missing.push({ kind, index: i, read });
            }
          });
        }
      };
      check("indoor", this.indoorSamples);
      check("outdoor", this.outdoorSamples);
      return missing;
    },
    canSubmitSampleFastq() {
      if (!this.hasStagedSampleFastq) return false;
      return this.missingFastqSlots.length === 0;
    }
  },
  methods: {
    ...mapActions([
      "sendNewDataV2",
      "testKitInfoV2",
      "sendSearchReqV2",
      "resendNotificationV2",
      "uploadMtcLabFiles",
      "getMtcLabFiles",
      "deleteMtcLabFile",
      "downloadMtcLabFile",
      "getKitLogV2",
      "saveUserSubmitedV2"
    ]),
    statusOf(s) {
      if (typeof s === "string") return s;
      return STATUS_MAP[s] || "shipped";
    },
    hydrateFromKit(kit) {
      // Shared between mounted() and the getTestKitInfoV2 watcher so a fresh
      // kit object from the store (post-save) re-syncs every locally-cached
      // field instead of leaving stale display values behind.
      if (!kit) return;
      this.kit = kit;
      this.selectedStatus = this.statusOf(kit.status);
      this.track_number = kit.track_number || null;
      this.ship_method = kit.ship_method || null;
      this.convertedKitId = this.convertKitId(kit.kit_id);
      if (kit.mtc_lab_files && Array.isArray(kit.mtc_lab_files)) {
        this.existingFiles = kit.mtc_lab_files;
      }
    },
    stopPropagation(event) {
      event.stopPropagation();
    },
    callPrint() {
      window.print();
    },
    showDropDownFn() {
      if (this.role === "superadmin") {
        this.showDropDown = !this.showDropDown;
        this.showSelectDrop = false;
      }
    },
    showSelectDropFn() {
      if (this.role === "superadmin") {
        this.showSelectDrop = !this.showSelectDrop;
      }
    },
    setItem(item) {
      const status = [
        "shipped", "activated", "lab_awaiting", "lab_received",
        "on_hold", "analysis_completed", "delivered"
      ];
      if (item === 10) this.selectedStatus = "analysis_failed";
      else if (item === 11) this.selectedStatus = "partially_failed";
      else if (item === 13) this.selectedStatus = "dna_extraction";
      else if (item === 14) this.selectedStatus = "sequencing";
      else if (item === 16) this.selectedStatus = "accepted";
      else this.selectedStatus = status[item];
      this.showDropDown = false;
      this.showSelectDrop = false;
    },
    editData() {
      const data = {
        kit_id: this.parseKitId(this.convertedKitId),
        collected_first_name: this.personalData ? this.personalData.firstName : undefined,
        collected_last_name: this.personalData ? this.personalData.lastName : undefined,
        status: this.selectedStatus,
        collected_email: this.personalData ? this.personalData.email : undefined
      };
      // Submitted kits flow through the inline-edit form (Project Name,
      // Sampling Date, Sampling Location, sample types). Mirror the V1
      // editDataSubmission shape.
      if (this.enableEdit) {
        data.title = this.editTitle;
        if (this.editSamplingDate) data.sampling_date = this.editSamplingDate;
        data.address = this.editAddress;
        data.city = this.editCity;
        data.state = this.editState;
        data.zip = this.editZip;
        data.visible_mold = this.editVisibleMold;
        data.musty_damp_odor = this.editMustyDampOdor;
        data.symptoms = this.editSymptoms;
        data.samples = (this.editSamples || []).map(s => ({
          id: s.id,
          type: s.type
        }));
      }
      // V1 parity: when edit mode is on AND the sidebar emitted updated user
      // details (testkit.user payload), persist the User separately via the
      // dedicated saveUserSubmitedV2 endpoint so user-level changes land in
      // the kit_v2_edit_logs alongside the kit changes.
      if (
        this.enableEdit
        && this.personalData
        && this.personalData.testkit
        && this.personalData.testkit.user
      ) {
        this.saveUserSubmitedV2({
          kit_id: this.kit.id,
          user: this.personalData.testkit.user
        }).catch(() => {
          // Sidebar may emit before required fields are filled; the kit save
          // below still proceeds and the user save can be retried.
        });
      }
      this.sendNewDataV2({ data, id: this.kit.id }).then(res => {
        if (this.statusOf(res.status) === "on_hold") {
          this.showComment();
        }
        this.saveTxt = "Data successfully saved";
        if (this.enableEdit) {
          this.cancelEdit();
        }
      });
    },
    editDetails() {
      this.enableEdit = true;
      this.showLog = false;
      this.editTitle = this.kit.title || "";
      this.editSamplingDate = this.kit.sampling_date
        ? String(this.kit.sampling_date).slice(0, 10)
        : "";
      const addr = (this.kit && this.kit.address) || {};
      this.editAddress = addr.address || "";
      this.editCity = addr.city || "";
      this.editState = addr.state || "";
      this.editZip = addr.zip || "";
      this.editVisibleMold = this.kit.visible_mold === true;
      this.editMustyDampOdor = this.kit.musty_damp_odor === true;
      this.editSymptoms = this.kit.symptoms === true;
      this.editSamples = (this.indoorSamples || []).map(s => ({
        id: s.id,
        type: s.type || ""
      }));
      // Bubble up so the parent ModalV2 flips `showEdit` on ModalInfoV2 and the
      // User Details sidebar swaps to editable inputs in sync.
      this.$emit("enableEdit", true);
    },
    cancelEdit() {
      this.enableEdit = false;
      this.activeSampleDropdown = -1;
      this.$emit("enableEdit", false);
    },
    openSampleDropdown(index) {
      this.activeSampleDropdown = this.activeSampleDropdown === index ? -1 : index;
    },
    closeSampleDropdown() {
      this.activeSampleDropdown = -1;
    },
    setSampleType(value, index) {
      if (!this.editSamples[index]) return;
      // Vue.set so the array element's `.type` mutation stays reactive.
      this.$set(this.editSamples, index, {
        ...this.editSamples[index],
        type: value
      });
      this.activeSampleDropdown = -1;
    },
    isSampleTypeTaken(option, index) {
      if (!Array.isArray(this.editSamples)) return false;
      return this.editSamples.some((s, i) => i !== index && s && s.type === option);
    },
    toggleLog() {
      this.showLog = !this.showLog;
      if (this.showLog) {
        this.enableEdit = false;
        this.getKitLogV2(this.kit.id);
      }
    },
    askDeleteFile(file) {
      if (!file || this.deletingFileId) return;
      this.fileActionSuccess = "";
      this.uploadValidationError = "";
      this.fileToDelete = file;
    },
    cancelDeleteFile() {
      if (this.deletingFileId) return;
      this.fileToDelete = null;
    },
    async confirmDeleteFile() {
      const file = this.fileToDelete;
      if (!file || this.deletingFileId) return;
      this.deletingFileId = file.id;
      this.uploadValidationError = "";
      this.uploadSuccess = false;
      this.fileActionSuccess = "";
      try {
        await this.deleteMtcLabFile(file.id);
        this.existingFiles = this.existingFiles.filter(f => f.id !== file.id);
        this.fileActionSuccess = `${file.file_name} was deleted.`;
        this.fileToDelete = null;
      } catch (err) {
        const msg =
          (err && err.response && err.response.data && err.response.data.message) ||
          (err && err.message) ||
          "Delete failed. Please try again.";
        this.uploadValidationError = msg;
      } finally {
        this.deletingFileId = null;
      }
    },
    async onDownloadFile(file) {
      if (!file || this.downloadingFileId) return;
      this.downloadingFileId = file.id;
      this.uploadValidationError = "";
      this.fileActionSuccess = "";
      try {
        await this.downloadMtcLabFile(file);
        this.fileActionSuccess = `${file.file_name} downloaded.`;
      } catch (err) {
        const msg =
          (err && err.response && err.response.data && err.response.data.message) ||
          (err && err.message) ||
          "Download failed. Please try again.";
        this.uploadValidationError = msg;
      } finally {
        this.downloadingFileId = null;
      }
    },
    async loadExistingFiles() {
      if (!this.kit || !this.kit.kit_id) return;
      try {
        const files = await this.getMtcLabFiles(this.kit.kit_id);
        this.existingFiles = files || [];
      } catch (err) {
        this.existingFiles = [];
      }
    },
    sampleResultText(sample) {
      if (!sample) return "In Progress";
      if (sample.result_label) return this.formatResultLabel(sample.result_label);
      if (typeof sample.result === "number" && sample.result > 3) return "N/A";
      switch (sample.result) {
        case -1: return "Unable To Process";
        case 0: return "Normal Fungal Ecology";
        case 1: return "Slightly Disrupted";
        case 2: return "Moderately Disrupted";
        case 3: return "Significantly Disrupted";
        default: return "In Progress";
      }
    },
    formatResultLabel(label) {
      if (!label) return "";
      return String(label)
        .toLowerCase()
        .split(/\s+/)
        .filter(Boolean)
        .map(w => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ");
    },
    sampleResultClass(sample) {
      if (!sample) return "";
      switch (sample.result) {
        case -1: return "darkgray";
        case 0: return "green";
        case 1: return "yellow";
        case 2: return "orange";
        case 3: return "red";
        default: return "";
      }
    },
    sampleResultColor(sample) {
      return this.sampleResultClass(sample);
    },
    sampleDisplayName(sample, index, kind) {
      if (kind === "indoor") {
        if (sample && sample.type) return sample.type;
        return `Indoor Sample #${index + 1}`;
      }
      if (sample && sample.value) return sample.value;
      return "Outdoor Sample";
    },
    sampleSlug(sample, index, kind) {
      const raw = this.sampleDisplayName(sample, index, kind);
      const cleaned = String(raw)
        .replace(/\s+/g, "_")
        .replace(/[^A-Za-z0-9_]/g, "");
      if (cleaned) return cleaned;
      return kind === "indoor"
        ? `IndoorSample${index + 1}`
        : `OutdoorSample${index + 1}`;
    },
    fastqExtension() {
      // Normalize every uploaded sample FASTQ to the canonical .fastq.gz
      // suffix regardless of whether the user picked .fastq or .fastq.gz.
      return ".fastq.gz";
    },
    isFastqGzFilename(name) {
      return /\.fastq(\.gz)?$/i.test(name || "");
    },
    isSlotMissing(kind, index, read) {
      return !this.getSampleFastq(kind, index, read) && !this.getStagedFastq(kind, index, read);
    },
    getSlotTypeError(kind, index, read) {
      const bucket =
        kind === "indoor" ? this.indoorFastqTypeErrors : this.outdoorFastqTypeErrors;
      const slots = bucket[index] || {};
      return slots[read] || "";
    },
    setSlotTypeError(kind, index, read, message) {
      const bucket =
        kind === "indoor" ? "indoorFastqTypeErrors" : "outdoorFastqTypeErrors";
      if (!this[bucket][index]) this.$set(this[bucket], index, {});
      if (message) {
        this.$set(this[bucket][index], read, message);
      } else {
        this.$delete(this[bucket][index], read);
      }
    },
    renameToSampleFile(file, kind, index, read) {
      const samples = kind === "indoor" ? this.indoorSamples : this.outdoorSamples;
      const sample = samples[index];
      const slug = this.sampleSlug(sample, index, kind);
      const ext = this.fastqExtension(file.name);
      const newName = `${slug}_${read}${ext}`;
      try {
        return new File([file], newName, {
          type: file.type || "application/octet-stream",
          lastModified: file.lastModified
        });
      } catch (e) {
        // Older browsers without File constructor fall back to a Blob + .name override.
        const blob = file.slice(0, file.size, file.type || "application/octet-stream");
        blob.name = newName;
        return blob;
      }
    },
    onSampleFastqSelected(e, kind, index, read) {
      const file = e.target.files[0];
      if (!file) return;
      this.sampleFastqSuccess = "";
      const refName =
        (kind === "indoor" ? "fastqInInput_" : "fastqOutInput_") + index + "_" + read;
      if (!this.isFastqGzFilename(file.name)) {
        this.setSlotTypeError(kind, index, read, "Only .fastq or .fastq.gz files are allowed");
        const ref = this.$refs[refName];
        if (ref) {
          const el = Array.isArray(ref) ? ref[0] : ref;
          if (el) el.value = "";
        }
        return;
      }
      this.setSlotTypeError(kind, index, read, "");
      const renamed = this.renameToSampleFile(file, kind, index, read);
      const bucket = kind === "indoor" ? "indoorFastqStaged" : "outdoorFastqStaged";
      if (!this[bucket][index]) this.$set(this[bucket], index, {});
      this.$set(this[bucket][index], read, renamed);
    },
    removeSampleFastq(kind, index, read) {
      const bucket = kind === "indoor" ? "indoorFastqStaged" : "outdoorFastqStaged";
      const slots = this[bucket][index];
      if (slots) {
        this.$delete(slots, read);
        if (!slots.R1 && !slots.R2) this.$delete(this[bucket], index);
      }
      this.setSlotTypeError(kind, index, read, "");
      const refName =
        (kind === "indoor" ? "fastqInInput_" : "fastqOutInput_") + index + "_" + read;
      const ref = this.$refs[refName];
      if (ref) {
        const el = Array.isArray(ref) ? ref[0] : ref;
        if (el) el.value = "";
      }
    },
    getStagedFastq(kind, index, read) {
      const bucket = kind === "indoor" ? this.indoorFastqStaged : this.outdoorFastqStaged;
      const slots = bucket[index] || {};
      return slots[read] || null;
    },
    getSampleFastq(kind, index, read) {
      const fileType =
        (kind === "indoor" ? "fastq_indoor_" : "fastq_outdoor_") + read.toLowerCase();
      return this.existingFiles.find(
        f => f.file_type === fileType && Number(f.sample_index) === Number(index)
      ) || null;
    },
    async uploadSampleFastqFiles() {
      if (!this.kit || !this.kit.kit_id) return;
      if (!this.canSubmitSampleFastq) return;
      this.sampleFastqSuccess = "";

      const files = [];
      const meta = [];

      const collect = (bucket, kind) => {
        Object.keys(bucket).forEach(idx => {
          const slots = bucket[idx] || {};
          ["R1", "R2"].forEach(read => {
            if (slots[read]) {
              files.push(slots[read]);
              meta.push({
                file_type:
                  (kind === "indoor" ? "fastq_indoor_" : "fastq_outdoor_") + read.toLowerCase(),
                sample_index: Number(idx)
              });
            }
          });
        });
      };
      collect(this.indoorFastqStaged, "indoor");
      collect(this.outdoorFastqStaged, "outdoor");

      if (files.length === 0) return;

      this.uploadingSampleFastq = true;
      try {
        const result = await this.uploadMtcLabFiles({
          kit_id: this.kit.kit_id,
          files,
          file_meta: meta
        });
        const newFiles = (result && result.files) || [];
        const newKeys = new Set(
          newFiles.map(f => `${f.file_type}:${f.sample_index}`)
        );
        const SLOT_TYPES = new Set([
          "fastq_indoor_r1",
          "fastq_indoor_r2",
          "fastq_outdoor_r1",
          "fastq_outdoor_r2"
        ]);
        this.existingFiles = [
          ...newFiles,
          ...this.existingFiles.filter(f => {
            if (!SLOT_TYPES.has(f.file_type)) return true;
            return !newKeys.has(`${f.file_type}:${f.sample_index}`);
          })
        ];
        this.indoorFastqStaged = {};
        this.outdoorFastqStaged = {};
        this.indoorFastqTypeErrors = {};
        this.outdoorFastqTypeErrors = {};
        this.sampleFastqSuccess = `${newFiles.length} FASTQ file${newFiles.length === 1 ? "" : "s"} uploaded.`;
        if (result && result.kit_status) {
          this.kit = { ...this.kit, status: result.kit_status };
          this.selectedStatus = this.statusOf(result.kit_status);
        }
      } catch (err) {
        // Backend completeness failures map back to specific slot errors so
        // they render under the matching upload field instead of as a global toast.
        const data = err && err.response && err.response.data;
        const missing = (data && data.data && data.data.missing) || [];
        if (Array.isArray(missing)) {
          missing.forEach(label => {
            const m = /^Indoor Sample #(\d+) (R1|R2)$/.exec(label);
            if (m) {
              this.setSlotTypeError("indoor", Number(m[1]) - 1, m[2], `${m[2]} FASTQ file is required`);
              return;
            }
            const o = /^Outdoor Sample (R1|R2)$/.exec(label);
            if (o) {
              this.setSlotTypeError("outdoor", 0, o[1], `${o[1]} FASTQ file is required`);
            }
          });
        }
      } finally {
        this.uploadingSampleFastq = false;
      }
    },
    async getFile() {
      this.showPreloader = true;
      await axios({
        url: `${this.api_url}/v2/testkits/${this.kit.id}/report/pdf`,
        method: "GET",
        responseType: "blob"
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `KIT-ID-${this.convertKitId(this.kit.kit_id)}.pdf`);
          document.getElementById("btns-complate-wrap").appendChild(link);
          link.click();
        })
        .then(() => (this.showPreloader = false));
    },
    resendLatestNotification(kit_id) {
      const data = { kit_id: kit_id };
      this.resendNotificationV2(data)
        .then(res => {
          if (res && res.data) {
            this.message = "Notice Resent.";
          } else {
            this.message = "No email address found.";
          }
          this.alertModal = true;
        })
        .catch(() => {
          this.message = "Failed to resend notice. Please try again.";
          this.alertModal = true;
        });
    },
    closeAlertModal(boolean) {
      this.alertModal = boolean;
    },
    showComment() {
      this.$emit("showComment", {
        txt: this.kit.reason_on_hold,
        show: true,
        id: this.kit.id
      });
    },
    closeModel() {
      if (this.showDropDown) this.showDropDown = false;
    },
    closeDropDown() {
      if (this.showSelectDrop) this.showSelectDrop = false;
    },
    closeModal() {
      this.$emit("closeModal", false);
    },
    shareStatus() {
      this.showShareStatus = true;
    },
    closeShareStatus(boolean) {
      this.showShareStatus = boolean;
    },
    date(localDate) {
      if (localDate !== null && typeof localDate !== "undefined" && localDate !== "") {
        var todayDate = localDate.slice(0, 10);
        let d = todayDate.split("-");
        if (d.length === 3 && d[0] && d[1] && d[2]) {
          return d[1] + "/" + d[2] + "/" + d[0];
        }
      }
      return "00/00/0000";
    },
    parseKitId(kitId) {
      const DASHES_REGEX = /[-\s]/g;
      return kitId ? kitId.replace(DASHES_REGEX, "").substr(0, 11).toUpperCase() : undefined;
    },
    convertKitId(kitId) {
      const raw = this.parseKitId(kitId);
      return raw
        ? `${raw.substr(0, 2)}-${raw.substr(2, 2)}-${raw.substr(4, 3)}-${raw.substr(7, 4)}`
        : undefined;
    }
  },
  inject: ["$validator"],
  watch: {
    // Keep the modal's local kit state in sync with the Vuex store so updates
    // saved via sendNewDataV2 / saveUserSubmitedV2 reflect in the UI without
    // requiring a modal close + reopen.
    getTestKitInfoV2(obj) {
      if (!obj) return;
      this.hydrateFromKit(obj);
    }
  },
  mounted() {
    const initial = this.$store.getters.getTestKitInfoV2 || {};
    this.hydrateFromKit(initial);
    if (
      initial && initial.id
      && (!initial.mtc_lab_files || !Array.isArray(initial.mtc_lab_files))
      && this.role === "superadmin"
    ) {
      this.loadExistingFiles();
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../styles/colors";

.com {
  max-width: 1050px;
  width: 100%;
  background-color: #fff;
  padding: 20px 35px 40px 35px;
  position: relative;
  overflow-y: auto;
}
.close {
  position: absolute;
  top: 25px;
  right: 30px;
  background-color: transparent;
  border: none;
  width: 25px;
  cursor: pointer;
  outline: none;
}
.button-container {
  display: flex;
  align-items: center;
  position: absolute;
  top: 25px;
  left: 30px;
}
.print-btn {
  background-color: #005eb8;
  color: #fff;
  border: none;
  outline: none;
  border-radius: 5px;
  font-size: 14px;
  padding: 6px 15px;
  cursor: pointer;
  font-family: TTNormsMedium, sans-serif;
}
.share-span {
  margin-left: 10px;
}
.share-btn-img {
  width: 20px;
  cursor: pointer;
}
.title {
  padding: 30px 0 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 16px;
  color: $gray;
  font-family: TTNormsMedium, sans-serif;
}
.id {
  display: flex;
  align-items: center;
  color: $blue;
  margin-top: 5px;
  font-size: 14px;
}
.kit-input {
  border: none;
  outline: none;
  color: $blue;
  text-align: center;
  font-family: TTNormsMedium, sans-serif;
  font-size: 14px;
  width: 180px;
  text-transform: uppercase;
}
.proj-wrap,
.date-wrap,
.location {
  display: flex;
  .col {
    width: 50%;
    padding: 0 10px;
  }
}
.item {
  margin: 10px 0;
  .item-title {
    font-family: TTNormsMedium, sans-serif;
    font-size: 13px;
    color: $blue;
    margin-bottom: 3px;
  }
  .item-val {
    font-size: 13px;
    color: $gray;
    font-family: TTNormsRegular, sans-serif;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &.noData {
      color: $lightGray;
    }
    &.status {
      position: relative;
    }
  }
}
.circle {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
  background-color: $blue;
  &.green { background-color: $green; }
  &.red { background-color: red; }
  &.orange { background-color: orange; }
  &.yellow { background-color: $yellow; }
  &.purple { background-color: #ac75bd; }
  &.skyblue { background-color: #87CEEB; }
  &.blue { background-color: $blue; }
}
.item-val-span {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 13px;
  &.hold {
    cursor: default;
  }
}
.item-val-img {
  width: 10px;
  margin-left: 5px;
}
.dropDown {
  position: absolute;
  background-color: #fff;
  border: 1px solid #e4e4e4;
  border-radius: 5px;
  z-index: 100;
  list-style: none;
  padding: 0;
  margin: 5px 0 0 0;
  min-width: 180px;
  .dropDown-item {
    padding: 8px 15px;
    cursor: pointer;
    font-size: 13px;
    color: $lightGray;
    &:hover {
      background-color: #f5f5f5;
    }
    &.undisabled {
      color: $gray;
      font-family: TTNormsMedium, sans-serif;
    }
  }
}
.filter-wrap {
  position: relative;
}
.filter-list-wrap {
  position: absolute;
  background-color: #fff;
  border: 1px solid #e4e4e4;
  border-radius: 5px;
  z-index: 100;
  list-style: none;
  padding: 0;
  margin: 5px 0 0 0;
  min-width: 180px;
  .filter-list-item {
    padding: 8px 15px;
    cursor: pointer;
    font-size: 13px;
    &:hover {
      background-color: #f5f5f5;
    }
    &.hide {
      display: none;
    }
  }
}
.onhold-btn {
  background-color: transparent;
  border: none;
  padding: 0;
  max-width: 15px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  margin: 0 0 0 5px;
  cursor: pointer;
}
.onhold-btn-img {
  max-width: 100%;
}
.details {
  padding: 10px;
  margin: 15px 0;
  .details-title {
    font-family: TTNormsMedium, sans-serif;
    font-size: 14px;
    color: $blue;
    margin-bottom: 10px;
  }
}
.row {
  display: flex;
  align-items: center;
  margin: 5px 0;
  .row-item {
    margin-right: 20px;
    font-size: 13px;
    color: $gray;
    font-family: TTNormsRegular, sans-serif;
    &.noData { color: $lightGray; }
  }
}
.status {
  font-family: TTNormsMedium, sans-serif;
  &.green { color: $green; }
  &.yellow { color: $yellow; }
  &.orange { color: orange; }
  &.red { color: red; }
  &.darkgray { color: $gray; }
}
.btns-complate-wrap {
  margin: 15px 0;
}
.download-wrap {
  display: flex;
  flex-direction: column;
}
.download-link {
  display: flex;
  align-items: center;
  margin: 5px 0;
  cursor: pointer;
  text-decoration: none;
  &.span {
    position: relative;
  }
}
.download {
  margin-right: 5px;
  img {
    width: 20px;
  }
}
.download-txt {
  font-size: 13px;
  color: $blue;
  font-family: TTNormsMedium, sans-serif;
  cursor: pointer;
  &.non-downloading {
    display: none;
    &.downloading {
      display: block;
      color: $lightGray;
    }
  }
}
.download-input {
  display: none;
}
.upload_csv {
  cursor: pointer;
}
.upload-img {
  width: 20px;
  transform: rotate(180deg);
}
.timer {
  display: inline-block;
  width: 20px;
  text-align: center;
  font-family: TTNormsMedium, sans-serif;
}
.uploadTxt {
  font-size: 12px;
  margin-left: 5px;
  .error {
    color: red;
  }
  .success {
    color: $green;
    margin-left: 6px;
  }
}
.confirm-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
}
.confirm-box {
  background-color: #fff;
  border-radius: 8px;
  padding: 22px 26px;
  max-width: 380px;
  width: 90%;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  font-family: TTNormsRegular, sans-serif;
}
.confirm-title {
  font-family: TTNormsMedium, sans-serif;
  color: $blue;
  font-size: 16px;
  margin-bottom: 10px;
}
.confirm-body {
  font-size: 13px;
  color: $gray;
  line-height: 1.4;
  margin-bottom: 18px;
  strong {
    color: $gray;
    word-break: break-all;
  }
}
.confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.confirm-btn {
  border: none;
  outline: none;
  border-radius: 4px;
  font-family: TTNormsMedium, sans-serif;
  font-size: 13px;
  padding: 7px 16px;
  cursor: pointer;
  &.cancel {
    background-color: #f0f0f0;
    color: $gray;
  }
  &.delete {
    background-color: #d9534f;
    color: #fff;
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}
.upload-block {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.slot-counts {
  display: flex;
  gap: 8px;
  margin-bottom: 6px;
}
.slot-pill {
  display: inline-block;
  font-family: TTNormsMedium, sans-serif;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 10px;
  background-color: #eef3f9;
  color: $blue;
  border: 1px solid #d4e0ee;
  &.full {
    background-color: #fde8e8;
    color: #b54141;
    border-color: #f1c4c4;
  }
}
.remove-file-btn {
  background: transparent;
  border: none;
  color: red;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  margin-left: 6px;
  padding: 0 4px;
  outline: none;
}
.add-fastq-btn {
  align-self: flex-start;
  background: transparent;
  border: 1px dashed $blue;
  color: $blue;
  font-size: 12px;
  font-family: TTNormsMedium, sans-serif;
  padding: 4px 10px;
  border-radius: 4px;
  cursor: pointer;
  margin: 5px 0;
  outline: none;
}
.upload-submit-btn {
  align-self: flex-start;
  background-color: $blue;
  color: #fff;
  border: none;
  font-size: 13px;
  font-family: TTNormsMedium, sans-serif;
  padding: 6px 14px;
  border-radius: 4px;
  cursor: pointer;
  margin: 8px 0 4px 0;
  outline: none;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
.uploaded-files-list {
  list-style: none;
  padding: 0;
  margin: 8px 0 0 0;
  font-size: 12px;
  li {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 3px 0;
  }
}
.file-type-badge {
  display: inline-block;
  padding: 1px 6px;
  border-radius: 3px;
  font-size: 10px;
  font-family: TTNormsMedium, sans-serif;
  color: #fff;
  background-color: $blue;
  &.type-fastq {
    background-color: #6b46c1;
  }
}
.sample-count {
  font-family: TTNormsRegular, sans-serif;
  color: $gray;
  font-size: 12px;
  margin-left: 6px;
}
.row-item.sample.room {
  display: flex;
  align-items: center;
  font-family: TTNormsMedium, sans-serif;
}
.row-item .noData {
  color: $lightGray;
}
.samples-block {
  width: 100%;
  padding: 18px 0;
}
.samples-block .details-title {
  font-family: TTNormsMedium, sans-serif;
  font-size: 14px;
  color: $blue;
  margin-bottom: 12px;
}
.sample-row {
  display: grid;
  grid-template-columns: minmax(180px, 1fr) minmax(220px, 2fr) minmax(140px, 1fr);
  align-items: center;
  width: 100%;
  padding: 10px 14px;
  background-color: #f9fafb;
  border: 1px solid #eef1f4;
  border-radius: 6px;
  margin-bottom: 8px;
  gap: 16px;
  box-sizing: border-box;
}
.sample-row:last-child {
  margin-bottom: 0;
}
.sample-row-label {
  display: flex;
  align-items: center;
  font-family: TTNormsMedium, sans-serif;
  font-size: 13px;
  color: $gray;
}
.sample-row-label .circle {
  margin-right: 8px;
}
.sample-row-name {
  font-family: TTNormsRegular, sans-serif;
  font-size: 13px;
  color: $gray;
  word-break: break-word;
}
.sample-row-name .noData {
  color: $lightGray;
}
.sample-row-status {
  font-family: TTNormsMedium, sans-serif;
  font-size: 13px;
  text-align: right;
}
@media (max-width: 768px) {
  .sample-row {
    grid-template-columns: 1fr;
    gap: 6px;
  }
  .sample-row-status {
    text-align: left;
  }
}
.fastq-block {
  border-top: 1px solid #d9d9d9;
  padding-top: 18px;
  margin-top: 6px;
}
.fastq-section {
  margin-bottom: 14px;
}
.fastq-subtitle {
  font-family: TTNormsMedium, sans-serif;
  font-size: 13px;
  color: $blue;
  margin-bottom: 10px;
}
.sample-card {
  background: #f9fafb;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 10px;
}
.sample-card-header {
  font-family: TTNormsMedium, sans-serif;
  font-size: 14px;
  color: $gray;
  margin-bottom: 8px;
}
.sample-card-slug {
  font-family: TTNormsRegular, sans-serif;
  font-size: 11px;
  color: $lightGray;
  margin-left: 6px;
}
.fastq-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 4px 0;
  flex-wrap: wrap;
}
.fastq-row-label {
  font-family: TTNormsMedium, sans-serif;
  font-size: 12px;
  color: $blue;
  min-width: 80px;
}
.fastq-existing {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  flex-wrap: wrap;
}
.required-marker {
  color: #d9534f;
  margin-left: 2px;
}
.slot-missing .download-txt.upload_csv {
  color: #d9534f;
  border-bottom: 1px dashed #d9534f;
}
.slot-error {
  color: #d9534f;
  font-size: 11px;
  font-family: TTNormsMedium, sans-serif;
  margin-top: 4px;
  flex-basis: 100%;
}
.uploaded-file-name {
  color: $gray;
}
.uploaded-file-date {
  color: $lightGray;
  margin-left: auto;
}
.upload-disabled-hint {
  font-size: 12px;
  color: $lightGray;
  font-style: italic;
  padding: 4px 0;
}
.file-action {
  font-size: 11px;
  font-family: TTNormsMedium, sans-serif;
  padding: 2px 8px;
  border-radius: 3px;
  cursor: pointer;
  background: transparent;
  text-decoration: none;
  outline: none;
  &.download-action {
    color: $blue;
    border: 1px solid $blue;
  }
  &.delete-action {
    color: red;
    border: 1px solid red;
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
}
.btn {
  display: block;
  margin: 15px auto 0 auto;
  width: 120px;
  height: 40px;
  border-radius: 25px;
  background-color: $green;
  color: #fff;
  border: none;
  outline: none;
  cursor: pointer;
  font-family: TTNormsMedium, sans-serif;
  font-size: 16px;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  &.save {
    margin-top: 10px;
  }
}
.saveTxt {
  text-align: center;
  color: $green;
  font-size: 13px;
  font-family: TTNormsMedium, sans-serif;
  margin-top: 5px;
}
.btn-link {
  color: $blue;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}
.validate-error {
  color: red;
  font-size: 12px;
  &.right {
    text-align: right;
  }
}
.resend-report-btn-wrap {
  margin: 10px 0;
}
.custom-mail {
  width: 20px;
  margin-right: 5px;
}
.status-wrap {
  position: relative;
}
.download-link {
  display: flex;
  position: relative;
  justify-content: flex-start;
  align-items: center;
  margin: 0 50px 0 0;
}
.download-link-btn {
  text-align: left;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
}
.download-circle {
  width: 30px;
  height: 30px;
  background-color: #03409a;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    max-width: 12px;
    height: auto;
    cursor: pointer;
  }
}
.download-txt-v1 {
  font-size: 14px;
  color: #03409a;
  padding: 0 0 0 5px;
  font-family: GothamPro, sans-serif;
}
.edit-input {
  padding: 4px 8px;
  border: 1px solid #cccccc;
  border-radius: 4px;
  font-family: TTNormsRegular, sans-serif;
  font-size: 13px;
  color: $gray;
  outline: none;
  width: 100%;
  max-width: 240px;
  &:focus {
    border-color: $blue;
  }
}
.edit-address {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-start;
  width: 100%;
  max-width: 320px;
}
.answers-border {
  border-bottom: 1px solid #d9d9d9;
  padding-bottom: 16px;
  margin-bottom: 8px;
}
.answers-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 0;
  font-family: TTNormsLight, sans-serif;
  font-size: 14px;
  color: #000;
}
.answer-group {
  display: inline-flex;
  align-items: center;
}
.answer-prompt {
  padding-right: 5px;
}
.answer {
  font-weight: 700;
  padding: 0 20px 0 5px;
  color: #000;
}
.answer-toggle-label {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  padding: 4px 14px;
  margin: 0 20px 0 5px;
  border-radius: 12px;
  background-color: #eef1f4;
  color: $gray;
  font-family: TTNormsMedium, sans-serif;
  font-size: 12px;
  user-select: none;
  transition: background-color 0.15s, color 0.15s;
  input {
    display: none;
  }
  &.active {
    background-color: $blue;
    color: #fff;
  }
}
.answer-toggle-text {
  line-height: 1;
}
.edit-address-row {
  display: flex;
  gap: 6px;
  width: 100%;
  .edit-input {
    max-width: none;
  }
  .edit-input--city { flex: 2; }
  .edit-input--state { flex: 1; }
  .edit-input--zip { flex: 1; }
}
.sample-dropdown-container {
  position: relative;
  width: 100%;
  max-width: 240px;
}
.sample-dropdown-input {
  width: 100%;
  max-width: 240px;
  padding-right: 24px;
  cursor: pointer;
  background-color: #fff;
}
.sample-dropdown-arrow {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 10px;
  pointer-events: none;
}
.sample-dropdown-list {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  right: 0;
  background-color: #fff;
  border: 1px solid #cccccc;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  list-style: none;
  margin: 0;
  padding: 4px 0;
  z-index: 50;
  max-height: 260px;
  overflow-y: auto;
}
.sample-dropdown-item {
  padding: 6px 12px;
  font-size: 13px;
  color: $gray;
  font-family: TTNormsRegular, sans-serif;
  cursor: pointer;
  &:hover:not(.disabled) {
    background-color: #eef3f9;
    color: $blue;
  }
  &.disabled {
    color: $lightGray;
    cursor: not-allowed;
  }
  &--input {
    padding: 4px 8px;
    border-top: 1px solid #eee;
    &:hover {
      background-color: transparent;
    }
  }
}
.sample-dropdown-other {
  width: 100%;
  padding: 4px 6px;
  border: 1px solid #dddddd;
  border-radius: 3px;
  font-family: TTNormsRegular, sans-serif;
  font-size: 12px;
  color: $gray;
  outline: none;
  &:focus {
    border-color: $blue;
  }
}
@media (max-height: 790px) {
  .com {
    overflow-y: scroll;
  }
  .com::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }
}
@media print {
  .com {
    width: 100%;
    max-width: 100%;
  }
  .close,
  .button-container,
  .btn,
  .resend-report-btn-wrap {
    display: none;
  }
}
</style>
